"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const use_theme_1 = __importDefault(require("../hooks/use-theme"));
const tailwind_1 = __importDefault(require("../utils/tailwind"));
const button_1 = __importDefault(require("./button"));
const styles = (0, tailwind_1.default)({
    container: `
    tw-flex
    tw-flex-col
    tw-items-stretch
    tw-justify-start
    tw-h-full
    tw-gap-2`,
    title: `
    tw-text-xl
    tw-text-center
    tw-w-4/5
    tw-self-center
    tw-font-medium`,
    contentContainer: `
    tw-flex
    tw-flex-col
    tw-items-center
    tw-flex-grow justify-center`,
    footer: `
    tw-flex
    tw-flex-row
    tw-justify-between
    tw-items-stretch
    tw-text-sm self-end`,
    footerText: `
    tw-font-medium`,
});
function ConnectorScreen({ title, content, footer }) {
    const theme = (0, use_theme_1.default)();
    return (react_1.default.createElement("div", { className: styles.container },
        react_1.default.createElement("h1", { className: styles.title, style: { color: theme.textSecondary } }, title),
        react_1.default.createElement("div", { className: styles.contentContainer }, content),
        footer && (react_1.default.createElement("div", { className: styles.footer },
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: styles.footerText, style: { color: theme.textTertiary } }, 'desc' in footer ? footer.desc : `Don't have ${footer.name}?`)),
            react_1.default.createElement("div", null,
                react_1.default.createElement(button_1.default, { as: "a", href: footer.url, target: "_blank", rel: "noreferrer" }, footer.CTA || 'GET'))))));
}
exports.default = ConnectorScreen;
// 296.500
// 248.762
//# sourceMappingURL=connector-screen.js.map